import React, { Component } from 'react'

import BarLowNote from './BarLowNote'
import BarOctave from './BarOctave'
import BarsGapCapSettings from './BarsGapCapSettings'
import BarsSplitPointSettings from './BarsSplitPointSettings'
import BarInfo from './BarInfo'

export default class BarsCapsSettings extends Component {

  render() {
    return (
      <div className="bars-caps-settings">
        <div className="bars-octave-lownote">
          <BarLowNote />
          <BarInfo />
          <BarOctave />
        </div>
        <div className="caps-splits">
          <BarsGapCapSettings />
          <BarsSplitPointSettings />
        </div>
      </div>
    )
  }
}
